module.exports = __webpack_public_path__ + "0c6231c2ea02cac74b845c74df6eaf8f.pdf";